// extracted by mini-css-extract-plugin
module.exports = {"title":"Table_title__1uZfu","table":"Table_table__1Z4f0","hideTitle":"Table_hideTitle__2nMN0","sticky":"Table_sticky__gz_os"};